import { render, staticRenderFns } from "./FlowSessions.vue?vue&type=template&id=99ffdca8&"
import script from "./FlowSessions.vue?vue&type=script&lang=js&"
export * from "./FlowSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports